import { http, RequestMethod } from '@/utils/http';
/**
 * 获取openId
 * @param {String} data
 */
export const getWxOpenIdApi = (data: Recordable) => {
    return http({
        url: '/get-wx-openid',
        method: RequestMethod.POST,
        data,
    });
};

/**
 * 获取支付宝openId
 * @param {String} data
 */
export const getAliOpenIdApi = (data: Recordable) => {
    return http({
        url: '/get-ali-openid',
        method: RequestMethod.POST,
        data,
    });
};

/**
 * 获取org_name
 * @param {Number} org_id
 */
export const getOrgNameApi = (org_id: number) => {
    return http({
        url: `/org-name/${org_id}`,
        method: RequestMethod.GET,
    });
};

/**
 * 获取支付配置
 * @param data
 */
export const getPayConfigApi = (data: any) => {
    return http({
        url: '/scan',
        method: RequestMethod.POST,
        data,
    });
};

/**
 * 获取订单详情
 * @param query
 */
export const getOrderDetailApi = (query: any) => {
    return http({
        url: '/common/detail',
        method: RequestMethod.GET,
        query,
    });
};
